import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeKeycloakCode } from "../../utils/Api";
import { useAuth } from "../../utils/AuthContext";

const KeycloakCallback: React.FC = () => {
  const navigate = useNavigate();
  const { setTokenFromKeycloak } = useAuth();
  const requestSent = useRef(false);

  useEffect(() => {
    if (requestSent.current) return; // Prevent duplicate execution in strict mode
    requestSent.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (!code) {
      console.error("Authorization code not found");
      navigate("/login");
      return;
    }

    const handleAuth = async (code: string) => {
      try {
        const { data } = await exchangeKeycloakCode(code);

        if (data.access_token) {
          setTokenFromKeycloak(data.access_token);
          // Check if there's a pending organization action
          const pendingOrgAcceptToken = sessionStorage.getItem("pendingOrgAcceptToken");
          const pendingOrgSetupToken = sessionStorage.getItem("pendingOrgSetupToken");
          if (pendingOrgAcceptToken) {
            sessionStorage.removeItem("pendingOrgAcceptToken");
            navigate(`/organization/accept?token=${pendingOrgAcceptToken}`);
          } else if (pendingOrgSetupToken) {
            navigate(`/organization/setup?token=${pendingOrgSetupToken}`);
          } else {
            navigate("/home/dashboard");
          }
        } else {
          console.error("Failed to get token:", data);
          navigate("/login");
        }
      } catch (error: any) {
        console.error("Error during token exchange:", error);
        navigate("/login");
      }
    };

    handleAuth(code);
  }, [navigate, setTokenFromKeycloak]);

  return (
    <div className="container mt-5 text-center">
      <h2>Processing authentication...</h2>
      <p>Please wait while we complete your login.</p>
    </div>
  );
};

export default KeycloakCallback;
